var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"volume-indicator"},_vm._l((_vm.boxes),function(box,index){return _c('div',{key:index,staticClass:"volume-box",class:{ active: index < _vm.activeBoxes }})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }